import Throttle from '../_utils/Throttle';

export default class PlayWhenScrolledTo {


	// Constructor
	constructor(asscroll, element) {
		this.asscroll = asscroll;
		this.element = element;
		this.scrollThrottle = Throttle(this.scroll.bind(this), 10);
		this.asscroll.on('update', this.scrollThrottle);
	}


	// Event Handlers
	scroll() {
		const { top } = this.element.getBoundingClientRect();
		const offset = 100; // how much into the viewport the element needs to be scrolled
		if (top <= window.innerHeight - offset) {
			this.asscroll.off('update', this.scrollThrottle);
			this.element.classList.add('play');
			delete this.asscroll;
			delete this.element;
			delete this.scrollThrottle;
			delete this;
		}
	}


}
